import * as z from 'zod';
import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import { validateBirthDate, validateCPF } from '../../../../utils/validations';

export const dependentsSchema = z.object({
  name: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(val => validaNomeCompleto(val), {
        message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
      }),
  ),
  birthDate: z
    .string()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
      message: 'Formato inválido (use DD/MM/AAAA)',
    })
    .refine(validateBirthDate, { message: 'Data de nascimento invalida' }),
  civilStatus: z.string().min(1, { message: 'Campo obrigatório' }),
  gender: z.string().min(1, { message: 'Campo obrigatório' }),
  parentage: z.string().min(1, { message: 'Campo obrigatório' }),
  cpf: z.optional(z.string()),
  cns: z.optional(z.string()),
  mothersName: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .refine(val => validaNomeCompleto(val), {
        message: 'Digite o nome completo sem abreviações (ex: João da Silva)',
      }),
  ),
});
